import { useMemo } from "react";
import styled from "styled-components";
import { Conditional, Spinner } from "@sablier/v2-components/atoms";
import { Warning } from "@sablier/v2-components/molecules";
import { tags } from "@sablier/v2-constants";
import { useT } from "@sablier/v2-locales";
import { _ } from "@sablier/v2-mixins";
import { Empty } from "~/client/components/atoms";
import { useActionsCurrent, usePollingAwareness } from "~/client/hooks";
import Footer from "./Footer";
import Item from "./Item";

const WrapperPartial = styled.div`
  ${(props) => props.theme.styles.column}
  & {
    width: 100%;
  }
`;

const Content = styled.div`
  ${(props) => props.theme.styles.column}
  & {
    row-gap: calc(${(props) => props.theme.sizes.edge} * 0.5);
    align-content: center;
    width: 100%;
    padding-inline: ${(props) => props.theme.sizes.modalEdge};
  }
`;

const Loading = styled.div`
  ${(props) => props.theme.styles.row}
  & {
    justify-content: center;
    width: 100%;
    min-height: 100px;
    padding: calc(${(props) => props.theme.sizes.edge} * 1);
  }
`;

const List = styled.div`
  ${(props) => props.theme.styles.column}
  & {
    width: 100%;
    overflow: auto;
  }
`;

const Wrapper = styled(WrapperPartial)`
  ${(props) => props.theme.medias.maxMD} {
    ${Content} {
      padding-inline: calc(${(props) => props.theme.sizes.edge} * 3 / 2);
    }
  }
  ${(props) => props.theme.medias.maxSM} {
    ${Content} {
      padding-inline: calc(${(props) => props.theme.sizes.edge} * 3 / 4);
    }
  }
`;

function Body() {
  usePollingAwareness({ condition: true, page: "profile" });
  const { error, isLoading, list } = useActionsCurrent();
  const { t } = useT();

  const isEmpty = useMemo(() => !list.length, [list]);

  return (
    <Wrapper>
      <Content>
        <Conditional on={isLoading}>
          <Loading>
            <Spinner />
          </Loading>
        </Conditional>
        <Conditional on={!isLoading && isEmpty}>
          <Empty content={t("structs.noActivity")} />
        </Conditional>
        <Conditional on={!isLoading && !isEmpty}>
          <List>
            {list.map((item) => (
              <Item action={item} key={item.id} />
            ))}
          </List>
        </Conditional>

        {!_.isNil(error) && (
          <Warning cy={tags.warning} value={_.toString(error)} />
        )}
      </Content>
      <Footer />
    </Wrapper>
  );
}

export default Body;
